<script>
import WishlistPanel from '@phoenix/mixins/components/wishlist/WishlistPanel';
import Panel from '@maison/components/common/Panel.vue';
import ProductCard from '@maison/components/product/ProductCard.vue';
import ProductPrice from '@phoenix/components/common/ProductPrice.vue';

export default {
  components: {
    Panel,
    ProductCard,
    ProductPrice,
  },

  mixins: [WishlistPanel],
};
</script>

<template>
  <panel
    id="wishlist-panel"
    open-from="end"
    :options="{ ...panelOptions, closeAll: true }"
    :title="$t('Wishlist.wishlistTitle')"
  >
    <template #content>
      <div v-if="isLoading" class="center center--and-text">
        <div class="loader loader--dark">
          <div class="loader__inner"></div>
        </div>
      </div>

      <template v-if="isShownAndLoaded">
        <ul v-if="products.length > 0" class="stack stack--spacing-4 cart-panel__product-cards-list">
          <li v-for="product in products" :key="product.modelReference" data-cy="cart-summary-item">
            <product-card
              v-bind="product"
              should-display-add-to-wishlist
              horizontal-only
              :show-tags="false"
              default-in-wishlist-icon="close"
            >
              <template #price>
                <product-price v-bind="localizePrice(product.price)" />
              </template>
            </product-card>
          </li>
        </ul>

        <div v-else>
          {{ $t('Wishlist.noProductText') }}
        </div>
      </template>
    </template>
  </panel>
</template>
